<template>
  <article>
    <div>
      <span class="xbed-sub-title">会员详情</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>会员管理</BreadcrumbItem>
        <BreadcrumbItem>会员详情</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Tabs style="width:1200px">
      <TabPane label="基本信息" name="basicInfo">
        <basic-info :basic="userInfo" :validCode="validCode" @userValidCode="onUserValidCode" @restPwd="onRestPwd" 
          @editIntegral="onEditIntegral">
        </basic-info>
      </TabPane>
      <TabPane label="港澳台/外籍人士身份验证" name="certificateInfo">
        <other-authentication :info="cardInfo" :token="qiniuToken" :imgToken="imgToken" @certificateAudit="certificateAudit" @getPrivateToken="getPrivateToken"></other-authentication>
      </TabPane>
      <TabPane label="大陆居民身份验证" name="authentication">
        <authentication :info="cardInfo" :token="qiniuToken" :imgToken="imgToken" @omsIdAudit="omsIdAudit" @omsFaceAudit="omsFaceAudit" @omsCardAudit="omsCardAudit" 
          @omsFaceAuditHandle="omsFaceAuditHandle" @getPrivateToken="getPrivateToken">
        </authentication>
      </TabPane>
      <TabPane label="邮寄地址" name="mailing-address">
        <post-address :postAddress="postAddress"  :privoicesList="provincesList" :citiesList="vipCityList" :countiesList="countyslist" 
          @queryProvice="queryProvincesList" @queryCity="onQuerycityList" @queryCounties="onQuerycountyslist" @addAddress="addAddress" 
          @delAdress="delAdress">
        </post-address>
      </TabPane>
      <TabPane label="推广信息" name="promoteInfo">
        <Form style="margin-left:5px">
          <FormItem label="推广渠道：" >
            <span>{{promoInfo.sources}}</span>
          </FormItem>
          <FormItem label="推广人员：">
            <span>{{promoInfo.cmsName}}</span>
          </FormItem>
        </Form>
      </TabPane>
    </Tabs>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";

import Authentication from './authentication'
import PostAddress from './mailing-address'
import BasicInfo from './basic-info'
import OtherAuthentication from './other-authentication'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.userId = Utils.getUrlParameterByName("userId");
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
    this.init();
  },
  data() {
    return {
      validCode: '',
      userInfo: {},
      cardInfo: {},
      promoInfo: {},
      postAddress: {},
      provincesList:[],
      vipCityList:[],
      countyslist:[],
      cityId:'',
      qiniuToken: '',
      imgToken: ''
    }
  },
  methods: {
    init() {
      this.queryUserById();
      this.findUserPromoInfo();
      this.userPostAddress();
      this.queryProvincesList();
      this.queryUserInfo();
      this.getQiniuToken();
    },
    async getQiniuToken() {
      this.qiniuToken = (await API.omsAPI[this.env].common.getUploadToken(true, this.token)).data;
    },
    async queryUserById() {
      let resp = (await API.omsAPI[this.env].php.queryUserById(
        {userId: this.userId}
      )).data;
      if(resp.retcode != 1){
        this.$Notice.error({
          title: resp.retmsg
        });
        return
      }
      this.userInfo = resp.retdata
    },
    async findUserPromoInfo() {
      let resp = (await API.omsAPI[this.env].php.findUserPromoInfo(
        {userId: this.userId}
      )).data;
      if(resp.retcode==0){
        this.promoInfo = resp.retdata
      }
    },
    async queryProvincesList() { //获取省份列表
      let ProvincesList = (await API.omsAPI[this.env].php.provincesList()).data
      this.provincesList = ProvincesList || [];
    },
    async onQuerycityList(id) { //获取城市列表
      let CityList = (await API.omsAPI[this.env].php.cityList(
        {id:id}
      )).data
      this.cityId = CityList[0].id;
      this.vipCityList = CityList;
    },
    async onQuerycountyslist(id) {//获取地区列表
      let Countyslist = (await API.omsAPI[this.env].php.countyslist(
        {id:id}
      )).data
      if(Countyslist.retCode){
        this.countyslist = []
      }else{
        this.countyslist = Countyslist;
      }
    },
    async userPostAddress() {
      let resp = (await API.omsAPI[this.env].php.userPostAddress(
        {userId: this.userId}
      )).data;
      this.postAddress = resp.retdata.content;
    },
    async userValidCode() {
      let resp = (await API.omsAPI[this.env].php.userValidCode(
        {userId: this.userId}
      )).data;
      this.validCode = resp.retdata.content;
    },
    async onUserValidCode() {
      let resp = (await API.omsAPI[this.env].php.userValidCode(
        {phone: this.userInfo.phone}
      )).data
      if(resp.retcode!=1){
        this.$Notice.error({
          title: resp.retmsg
        })
      }
      this.validCode = resp.retdata.code;
    },
    async onRestPwd(param) {
      param.lodgerId = this.userId;
      let resp = (await API.omsAPI[this.env].php.changePwd(param)).data;
      if(resp.retcode != 1){
        this.$Notice.error({
          title: resp.retmsg
        })
        return;
      }
      this.$Notice.success({
        title: '修改成功'
      })
    },
    async onEditIntegral(param) {
      param.userId = this.userId;
      let resp = (await API.omsAPI[this.env].php.editIntegral(param)).data;
      if(resp.retcode != 1){
        this.$Notice.error({
          title: resp.retmsg
        })
        return;
      }
      this.$Notice.success({
        title: '修改成功'
      });
      this.queryUserById();
    },
    async queryUserInfo() {
      let resp = (await API.omsAPI[this.env].vip.queryUserById(
        {userId: this.userId},
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: resp.msg
        });
        return
      }
      this.cardInfo = resp;
    },
    async omsIdAudit(param) { //人工审核身份验证
      let resp = (await API.omsAPI[this.env].vip.omsIdAudit(param,this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        })
      }else{
        this.$Notice.success({
          title: '操作成功'
        });
        this.queryUserInfo();
      }
    },
    async omsFaceAuditHandle(param) {  //人工审核人脸
      let resp = (await API.omsAPI[this.env].vip.omsFaceAuditHandle(param,this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        })
      }else{
        this.$Notice.success({
          title: '操作成功'
        });
        this.queryUserInfo();
      }
    },
    async omsFaceAudit(param) { // 人脸照片验证
      let resp = (await API.omsAPI[this.env].vip.omsFaceAudit(param,this.token)).data;
      if( resp.faceState == 2 ){
        this.$Notice.success({
          title: '操作成功'
        })
      }
      if(!resp.retCode ){
        resp.faceState != 2 && this.$Notice.success({
          // title: resp.msg
          title: resp.faceRejectReason
        })
      }else{
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        });
      }
      this.queryUserInfo();
    },
    async omsCardAudit(param) { // 身份证照片验证
      let resp = (await API.omsAPI[this.env].vip.omsCardAudit(param,this.token)).data;
      if(!resp.retCode){
        this.$Notice.info({
          title: resp.idCheckResult
        })
      }else{
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        });
      }
      this.queryUserInfo();
    },
    async addAddress(param) {  // 添加/编辑邮寄地址
      param.userId = this.userId;
      let resp = (await API.omsAPI[this.env].php.addPostAddress(param, this.token)).data;
      if(resp.retcode==1){
        this.$Notice.success({
          title: '操作成功'
        })
        this.userPostAddress();
      }else {
         this.$Notice.success({
          title: '操作失败',
          desc: resp.msg
        })
      }
    },
    async delAdress(addressId) { // 删除邮寄地址
      let resp = (await API.omsAPI[this.env].php.delPostAddress({addressId:addressId}, this.token)).data;
      if(resp.retcode==1){
        this.$Notice.success({
          title: '操作成功'
        });
        this.userPostAddress();
      }else {
         this.$Notice.success({
          title: '操作失败'
        })
      }
    },
    async certificateAudit(param) { //外籍人士身份验证
      let resp = (await API.omsAPI[this.env].vip.certificateAudit(param, this.token)).data;
      if(!resp.retCode){
        this.$Notice.info({
          title: '操作成功'
        })
        this.queryUserInfo();
      }else{
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        });
      }
    },
    async getPrivateToken(imgUrl) {
      let resp = (await API.omsAPI[this.env].vip.getPrivateToken(imgUrl,this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: resp.msg
        })
      }else{
        this.imgToken = resp
      }
    }

  },
  components: {
    'authentication' :Authentication,
    'post-address': PostAddress,
    'basic-info': BasicInfo,
    'other-authentication': OtherAuthentication,
  }
}
</script>

  


// WEBPACK FOOTER //
// src/pages/vip/vip-detail/index.vue